var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lastPage > 1)?_c('v-pagination',{staticClass:"mt-5",attrs:{"length":_vm.lastPage,"total-visible":8},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }